import { useEffect } from 'react'

const useChangeLanguageOnError = (errors, changeLanguage, key) => {
  useEffect(() => {
    if (errors && Object.keys(errors)?.length > 0) {
      const languages = Object.keys(errors)
      const keyError = Object.keys(errors[languages[0]])?.[0]
      if (keyError === key) {
        changeLanguage(languages[0])
      }
    }
  }, [changeLanguage, errors, key])
}

export default useChangeLanguageOnError
